module.exports = __webpack_public_path__ + "static/191011-BS-IGB-HM-CR-Ghoulish-307b7b8b6061d212b53f5ac61194427c.jpg";